// <ott-cart-addon>: one-tap add of an add-on product from the cart drawer (snippets/ott-cart-addons.liquid).
// Copied from Costiera's costiera-cart-upsell.js (read only). Loaded once from snippets/cart-drawer.liquid;
// Horizon morphs the drawer markup, so listen on the element itself and read the button and select at event time.
class OttCartAddon extends HTMLElement {
  connectedCallback() {
    if (this.wired) return;
    this.wired = true;
    this.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const button = event.target.closest('.ott-addon__add');
      if (button instanceof HTMLButtonElement) this.add(button);
    });
    this.addEventListener('change', (event) => {
      if (!(event.target instanceof HTMLSelectElement) || !event.target.matches('[data-variant]')) return;
      const option = event.target.selectedOptions[0];
      const price = this.querySelector('[data-price]');
      // Our own Liquid money markup (price + optional <s>compare-at</s>).
      if (option && price) price.innerHTML = option.dataset.priceHtml || '';
    });
  }

  /** @param {HTMLButtonElement} button */
  async add(button) {
    if (button.getAttribute('aria-busy') === 'true') return;
    button.setAttribute('aria-busy', 'true');
    const select = this.querySelector('[data-variant]');
    const variantId = Number(select instanceof HTMLSelectElement ? select.value : this.dataset.variantId);
    const offer = await import(this.dataset.offerModule || '');
    await offer.addLinesToCart([{ id: variantId, quantity: 1 }], this);
    button.removeAttribute('aria-busy');
  }
}

if (!customElements.get('ott-cart-addon')) customElements.define('ott-cart-addon', OttCartAddon);
